import * as Immutable from "immutable";
import { Param } from "./param";

export class MultiChoiceParam extends Param {

}